import React, { useEffect } from "react";
import DaeguMap from "./daegumap";

const MapMain: React.FC = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
          <DaeguMap />
        </>
    )
}

export default MapMain;